import React, { useEffect, useState } from "react";
import useProducts from "../../hooks/useProducts";
import useUser from "../../hooks/useUser";
import toast from "react-hot-toast";
import NoEncontrado from "../../assets/images/Banner_no_serie2.png";

function SinImagen() {
  return (
    <div
      className="img-fluid d-flex flex-column align-items-center justify-content-center"
      style={{
        aspectRatio: "1 / 1",
        maxHeight: 300,
        background: "#f1f1f1",
        borderRadius: 8,
        color: "#9a9a9a",
        gap: 8,
      }}
    >
      <svg
        width="56"
        height="56"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <path d="M21 15l-5-5L5 21" />
      </svg>
      <span style={{ fontSize: 14 }}>Sin imagen disponible</span>
    </div>
  );
}

export default function Ventas({
  item,
  index,
  error,
  successs,
  message,
  Arreglo,
  setArreglo,
}) {
  const {
    Productos,
    setProductos,
    Status,
    setStatus,
    Mensaje,
    setMensaje,
    ProductosGetService,
  } = useProducts();
  const { tokenFull, Dealer } = useUser();
  const [Error, setError] = useState(false);
  const [enCampana, setEnCampana] = useState(false);
  const [limiteAlcanzado, setLimiteAlcanzado] = useState(false);
  const [campanaVerificada, setCampanaVerificada] = useState(false);
  const [imagenConError, setImagenConError] = useState(false);
  const ENDPOINT = process.env.REACT_APP_BASE_URL;

  const producto =
    Array.isArray(Productos) && Productos[0] ? Productos[0] : null;

  useEffect(() => {
    setImagenConError(false);
  }, [producto?.imagen]);

  useEffect(() => {
    if (!Dealer || !tokenFull) return;
    fetch(
      `${process.env.REACT_APP_API_URL}/tiendas-campana/verificar/${Dealer}`,
      { headers: { Authorization: `Bearer ${tokenFull}` } }
    )
      .then((res) => res.json())
      .then((data) => {
        setEnCampana(data.en_campana);
        setLimiteAlcanzado(Boolean(data.limite_alcanzado));
      })
      .catch(() => {
        setEnCampana(false);
        setLimiteAlcanzado(false);
      })
      .finally(() => setCampanaVerificada(true));
  }, [Dealer, tokenFull]);

  const ChangeInfo = (value, name) => {
    const newArreglo = Arreglo.map((row, i) =>
      i === index ? { ...row, [name]: value } : row
    );
    setArreglo(newArreglo);
  };

  const ChangeMultiple = (fields) => {
    const newArreglo = Arreglo.map((row, i) =>
      i === index ? { ...row, ...fields } : row
    );
    setArreglo(newArreglo);
  };

  const handleOnChange = (e) => {
    const value = e.target.value;

    // Cualquier edición invalida la búsqueda anterior: no debe quedar
    // un producto/puntos de un número de serie distinto pegado a esta fila.
    ChangeMultiple({ NoSerie: value, SelectedEquipo: "", PuntosSave: "" });
    setProductos([]);
    setStatus("");
    setMensaje("");

    if (value.length !== 9) {
      return;
    }

    const duplicado = Arreglo.some(
      (row, i) => i !== index && row.NoSerie === value
    );

    if (duplicado) {
      setError(true);
      toast.error("El número de serie ya existe");
      return;
    }

    const data = new FormData();
    data.append("serie", value);
    data.append("num_dis", Dealer);
    setError(false);
    ProductosGetService(data, tokenFull);
  };

  useEffect(() => {
    if (!Array.isArray(Productos) || Productos.length === 0) return;
    if (Productos[0] === false) return;

    const { id, puntos } = Productos[0];
    const newArreglo = Arreglo.map((row, i) =>
      i === index ? { ...row, SelectedEquipo: id, PuntosSave: puntos } : row
    );
    setArreglo(newArreglo);
  }, [Productos]);

  useEffect(() => {
    if (error) {
      setError(true);
    }
  }, [message, error]);

  useEffect(() => {
    if (successs) {
      setError(false);
    }
  }, [message, successs]);

  const EliminarSerie = (rowIndex) => {
    setArreglo(Arreglo.filter((_, i) => i !== rowIndex));
  };

  return (
    <>
      <div className="row">
        <div className="col-md-6 d-flex justify-content-center">
          {item.NoSerie !== "" &&
            (producto ? (
              producto.imagen && !imagenConError ? (
                <img
                  className="img-fluid "
                  src={`${ENDPOINT}/images/productos/${producto.imagen}`}
                  alt={producto.modelo || "Producto"}
                  onError={() => setImagenConError(true)}
                  style={{ maxHeight: 300, width: "auto", objectFit: "contain" }}
                />
              ) : (
                <SinImagen />
              )
            ) : (
              <img
                className="img-fluid "
                src={NoEncontrado}
                alt="teser left"
              />
            ))}
        </div>
        <div className="col-md-6">
          <div className="row">
            {index >= 1 && (
              <div className="col-md-12 d-flex justify-content-end">
                <button
                  className="btn btn-danger btn-s"
                  onClick={() => EliminarSerie(index)}
                >
                  X
                </button>
              </div>
            )}

            <div className="col-md-12">
              <label htmlFor={`no-serie-${index}`}>
                No. de serie ( 9 numeros )
              </label>
              <input
                id={`no-serie-${index}`}
                type="text"
                className={Error ? "form-control is-invalid" : "form-control"}
                maxLength="9"
                value={item.NoSerie}
                onChange={handleOnChange}
              />
              {Status === "disponible" && (
                <span className="badge bg-success">Producto Disponible</span>
              )}
              {Status === "ocupado" && (
                <span className="badge bg-danger">
                  Este producto ya fue registrado
                </span>
              )}
              {Status === "no disponible" && (
                <span className="badge bg-warning">
                  Producto No Disponible
                </span>
              )}
              {Status === "producto no encontrado en la familia economica" && (
                <span className="badge bg-danger">{Mensaje}</span>
              )}
              <br />
            </div>
            <div className="col-md-12">
              <label htmlFor={`modelo-${index}`}>Modelo</label>
              <input
                id={`modelo-${index}`}
                type="text"
                className="form-control"
                disabled={true}
                value={producto ? producto.modelo : ""}
                onChange={(e) => ChangeInfo(e.target.value, "SelectedEquipo")}
              />
              <br />
            </div>
            <div className="col-md-12">
              <label htmlFor={`puntos-${index}`}>Puntos para tu ranking</label>
              <input
                id={`puntos-${index}`}
                type="text"
                className="form-control"
                disabled={true}
                value={producto ? producto.puntos : ""}
                onChange={(e) => ChangeInfo(e.target.value, "PuntosSave")}
              />
              <br />
            </div>
            <input
              type="hidden"
              className="form-control"
              disabled={true}
              value={producto ? producto.id : ""}
              onChange={(e) => ChangeInfo(e.target.value, "ModeloId")}
            />
            <br />
            {campanaVerificada && enCampana && (
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`cupon-${index}`}
                  checked={
                    Array.isArray(item.tags) && item.tags.includes("coupon")
                  }
                  onChange={(e) => {
                    const checked = e.target.checked;
                    const puntosBase = producto ? producto.puntos : 0;
                    ChangeMultiple({
                      tags: checked ? ["coupon"] : null,
                      PuntosSave: checked ? puntosBase * 3 : puntosBase,
                    });
                  }}
                />
                <label className="form-check-label" htmlFor={`cupon-${index}`}>
                  Esta venta incluye cupón "Tu equipo al 100"
                </label>
              </div>
            )}
            {campanaVerificada && !enCampana && limiteAlcanzado && (
              <p className="text-muted fst-italic">
                Los cupones disponibles de "Tu equipo al 100" para tu distribuidor ya se agotaron.
              </p>
            )}
            <br />
          </div>
        </div>
        <div className="col-md-12">
          <hr style={{ background: "#ed7100" }} />
        </div>
      </div>
    </>
  );
}
